import { render, staticRenderFns } from "./ResetAturUlangView.vue?vue&type=template&id=2ebf9c83&scoped=true"
import script from "./ResetAturUlangView.vue?vue&type=script&lang=js"
export * from "./ResetAturUlangView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf9c83",
  null
  
)

export default component.exports